import React, { useEffect } from 'react';
import { Button } from './ui/button';
import { Calendar } from 'lucide-react';

const ContactForm = () => {
  useEffect(() => {
    // Calendly Widget laden
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const openCalendly = () => {
    // Öffne Calendly in einem neuen Fenster
    window.open('https://calendly.com/patrick-2besales/linkedin-ai-agent-beratungsgesprach', '_blank', 'width=800,height=800');
  };

  return (
    <div className="space-y-8">
      <div className="text-left space-y-2 mb-8">
        <h3 className="text-2xl font-bold text-slate-900">
          Kostenloses Beratungsgespräch vereinbaren
        </h3>
        <p className="text-slate-600">
          Buchen Sie direkt einen Termin in unserem Kalender.
        </p>
      </div>

      {/* Calendly Button */}
      <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-8 border-2 border-blue-200">
        <div className="text-center space-y-4">
          <Calendar className="w-16 h-16 text-blue-600 mx-auto" />
          <h4 className="text-xl font-bold text-slate-900">
            Direkt Termin buchen
          </h4>
          <p className="text-slate-600">
            Wählen Sie einen passenden Termin in unserem Kalender
          </p>
          <Button 
            onClick={openCalendly}
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 py-6 text-lg transition-all duration-300 hover:shadow-lg w-full"
          >
            <Calendar className="mr-2 h-5 w-5" />
            Jetzt Termin buchen
          </Button>
        </div>
      </div>

      {/* Calendly Inline Widget */}
      <div 
        className="calendly-inline-widget rounded-2xl overflow-hidden shadow-xl border-2 border-slate-200" 
        data-url="https://calendly.com/patrick-2besales/linkedin-ai-agent-beratungsgesprach?hide_event_type_details=1&hide_gdpr_banner=1&primary_color=2563eb"
        style={{ minWidth: '320px', height: '700px' }}
      />

      <p className="text-sm text-slate-500 text-center">
        Mit der Terminbuchung akzeptieren Sie unsere Datenschutzbestimmungen
      </p>
    </div>
  );
};

export default ContactForm;
